import { render } from "./disPlaySinItem.vue?vue&type=template&id=3d2a7c5b"
import script from "./disPlaySinItem.vue?vue&type=script&lang=js"
export * from "./disPlaySinItem.vue?vue&type=script&lang=js"

import "./disPlaySinItem.vue?vue&type=style&index=0&id=3d2a7c5b&lang=css"
script.render = render

export default script